import React from 'react';
import {
  Wrapper,
  Bold,
  Container,
  Step
} from './styled';

interface Props {
  positionOf?: Array<number>;
  title?: string;
  className?: string;
}

export const BreadCrumb: React.FC<Props> = ({
  positionOf,
  title,
  className
}) => (
  <Wrapper className={className}>
    <Container>
      { title && <Bold>{title}</Bold>}
      { positionOf && positionOf.length > 0 && 
        <Step>
          <Bold>Paso {positionOf[0]}</Bold> de {positionOf[1]}
        </Step>
      }
    </Container>
  </Wrapper>
);